module.exports = __webpack_public_path__ + "img/presentation.ab1773ed.svg";